namespace GeniuzPOS.LogManage {
    export interface LogApiPathForm {
        ApiPath: Serenity.StringEditor;
        Path: Serenity.StringEditor;
        ApiDesc: Serenity.StringEditor;
        Paramiter: Serenity.StringEditor;
    }

    export class LogApiPathForm extends Serenity.PrefixedContext {
        static formKey = 'LogManage.LogApiPath';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LogApiPathForm.init)  {
                LogApiPathForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(LogApiPathForm, [
                    'ApiPath', w0,
                    'Path', w0,
                    'ApiDesc', w0,
                    'Paramiter', w0
                ]);
            }
        }
    }
}
